export const DEFAULT_NPPV_API_URI = 'http://test-nppv.bajiesleep.com/api/assistant/h5'

export function resolveNppvApiUri (value) {
  return value?.trim() || DEFAULT_NPPV_API_URI
}
